const updateCurrentUser = (state, { payload: { user } }) => {
	state.currentUser = user;
};

export default updateCurrentUser;
